import React from "react";
import { createMemoryRouter, RouteObject } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import EntityHandlerPage from "./pages/EntityHandlerPage";
import ConsultantPage from "./features/consultant/ConsultantPage";
import CandidatePage from "./features/candidate/CandidatePage";
import RelationPage from "./features/relation/RelationPage";
import RelationContactPage from "./features/relation-contact/RelationContactPage";
import DocumentPage from "./features/document/DocumentPage";
import DocumentForm from "./features/document/form/DocumentForm";
import NoteForm from "./features/note/form/NoteForm";
import EmailLinkForm from "./features/link-to/EmailLinkForm";
import LearnMore from "./pages/LearnMore";

export const createAppRouter = () => {
  const routes: RouteObject[] = [
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/handler",
      element: <EntityHandlerPage />,
    },
    {
      path: "/consultant/:uid",
      element: <ConsultantPage />,
    },
    {
      path: "/candidate/:uid",
      element: <CandidatePage />,
    },
    {
      path: "/relation/:uid",
      element: <RelationPage />,
    },
    {
      path: "/relationcontact/:uid",
      element: <RelationContactPage />,
    },
    {
      path: "/document-details",
      element: <DocumentPage />,
    },
    {
      path: "/document-upload",
      element: <DocumentForm />,
    },
    {
      path: "/note-form",
      element: <NoteForm />,
    },
    {
      path: "/link-to-related-items",
      element: <EmailLinkForm />,
    },
    {
      path: "/learn-more",
      element: <LearnMore />,
    },
    {
      path: "*",
      element: <LoginPage />,
    },
  ];

  return createMemoryRouter(routes);
};